const TZ = "Asia/Kolkata";

export const fmtIST = (iso, opts = {}) =>
  new Date(iso).toLocaleString("en-IN", {
    timeZone: TZ, weekday: "short", day: "numeric", month: "short",
    hour: "numeric", minute: "2-digit", ...opts,
  });

export const fmtISTDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", { timeZone: TZ, weekday: "long", day: "numeric", month: "long", year: "numeric" });

export const fmtISTTime = (iso) =>
  new Date(iso).toLocaleTimeString("en-IN", { timeZone: TZ, hour: "numeric", minute: "2-digit" });

export const fmtISTDay = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", { timeZone: TZ, day: "numeric", month: "short", year: "numeric" });

export const toISTInput = (iso) =>
  new Date(iso).toLocaleString("sv-SE", { timeZone: TZ }).replace(" ", "T").slice(0, 16);

export const fromISTInput = (value) => `${value}:00+05:30`;
